import script from "./EventProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./EventProfile.vue?vue&type=script&setup=true&lang=js"

import "./EventProfile.vue?vue&type=style&index=0&id=4199b572&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4199b572"]])

export default __exports__